var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 21 22","width":"21","height":"22"}},[_c('path',{attrs:{"d":"M10.507 20.333a9.333 9.333 0 1 0 0-18.667 9.333 9.333 0 0 0 0 18.667z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M6.506 11l2.667 2.666 5.333-5.333"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }